/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro1.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro2.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260105_img_p1.png?v=1767599278',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro3.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro4.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260105_img_p2.png?v=1767599278',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro5.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro6.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260105_img_p3.png?v=1767599278',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro7.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro8.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260105_img_p4.png?v=1767599278',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro9.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro10.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260105_img_p5.png?v=1767599278',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro11.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro12.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260105_img_p6.png?v=1767599278',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro13.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro14.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260105_img_p7.png?v=1767599278',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro15.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260104-pro16.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20260105_img_p8.png?v=1767599278',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20250916-p2.png',
    "https://cdn.shopify.com/s/files/1/0816/1201/3889/files/2-1_122ec003-1058-4bff-a450-eae503f3983f.png?v=1761128449",
    "https://cdn.shopify.com/s/files/1/0816/1201/3889/files/5_5561350a-2e64-4c98-8692-01d6c0697acf.png?v=1761128448",
    "https://cdn.shopify.com/s/files/1/0816/1201/3889/files/8-hei.png?v=1761128448",
    "https://cdn.shopify.com/s/files/1/0816/1201/3889/files/2_f10ff077-53c8-4555-a2ee-70ce42930e3c.png?v=1761128448",
    "https://cdn.shopify.com/s/files/1/0816/1201/3889/files/3_a1da6639-6ff4-4a0c-8688-bd89c59d0750.png?v=1761128448",
    "https://cdn.shopify.com/s/files/1/0816/1201/3889/files/5_2e52a1bb-56ec-4629-adf7-d3edd3e34137.png?v=1761130303",
    "https://cdn.shopify.com/s/files/1/0816/1201/3889/files/5_8b07ffd6-de6c-4a6d-bf63-d2582389210b.png?v=1761128448",
    
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20250916-p1.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/2-1.png?v=1761128448',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/5_184cb038-e629-4d2e-9f32-086bb0eb0644.png?v=1761128448',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/8-chen.png?v=1761128449',
    "https://cdn.shopify.com/s/files/1/0816/1201/3889/files/2_48416db3-d6a5-4382-b06b-df6b339c4f6f.png?v=1761128448",
    "https://cdn.shopify.com/s/files/1/0816/1201/3889/files/3_7603e605-8a2f-42b8-9585-2878c8d2ea04.png?v=1761128448",
    "https://cdn.shopify.com/s/files/1/0816/1201/3889/files/5_0ccd752b-6305-4fb8-a981-6ed6733ec728.png?v=1761130302",
    "https://cdn.shopify.com/s/files/1/0816/1201/3889/files/5_faab3b9f-6617-468b-b5f3-1a3a570f3a31.png?v=1761128448",

    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20250916-b1.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20250916-b2.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20250916-b3.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20250916-b4.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20250916-A1.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20250916-A2.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20250916-A3.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20250916-A4.png',
    'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20250916-A5.png',
  ]

  let spswiper0 = new Swiper('.sp-swiper2', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 4000,
    },
    on: {
      slideChange: function (e) {
        $('#swiper-btns .sp-swiper-option')
          .eq(e.realIndex)
          .addClass('active')
          .siblings()
          .removeClass('active')
      },
    },
    loop: true,
  })
  // 点击切换轮播
  $('#swiper-btns .sp-swiper-option').click(function () {
    $(this).addClass('active').siblings().removeClass('active')
    spswiper0.slideTo($(this).index() + 1)
  })

  new Swiper('.sp-swiper3', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 1,
    },
    speed: 6000,
    spaceBetween: 19,
    slidesPerView: 'auto',
    loop: true,
  })

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      let scale = document.body.clientWidth / 1080
      $('#root').css('zoom', scale)

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              let scale = document.body.clientWidth / 1080
              $('#root').css('zoom', scale)
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        let _topHeight =
          $('.time-part').height() +
          $('.sp-header-top').height() +
          $('.sp-nav').height()
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            _topHeight * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })

    // 找到所有跳转绑品的锚点链接
    var binds = document.querySelectorAll('a[href^="#add-to-cart-form"]')
    binds.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('add-to-cart-form');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('add-to-cart-form') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        let _topHeight =
          $('.time-part').height() +
          $('.sp-header-top').height() +
          $('.sp-nav').height()
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            _topHeight * $('div#root').css('zoom') +
            530 * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  let sp_price1 = 23.8
  let sp_price2 = 49.9

  function calcTotal(price, num) {
    let result = Number(price) * Number(num)
    return result.toFixed(2)
  }

  let prods = window.product
  function getCur() {
    let color = $('#sp-color div.active').attr('data-val')
    let size = $('#sp-num div.active').attr('data-val')
        let size2 = $('#sp-size div.active').attr('data-val')
    return prods.filter(
      item => item.option1 == color && item.option2 == size &&item.option3 == size2
    )[0]
  }
  function changePrice() {
    let num = $('#calcNumber').val()
    let price = ((getCur().price * num) / 100).toFixed(2)
    let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)

    let off_font =
      100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
    $('.product-part .price-group .sp-p span').html(off_font)
  }
  $('.sp-btn-style').click(function () {
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })
  $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    changePrice()
  })
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice()
  })

  $('.sp-option').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')

    let colorOptions = $('#sp-color .sp-option.active').index()
    let numOptions = $('#sp-num .sp-option.active').index()
    let size = $('#sp-size .sp-option.active').index()
    let _index = numOptions *6+colorOptions + size*3
    console.log(numOptions,colorOptions,size,_index)
    $('.product-part .sp-img-p')[0].src = spImgList[_index]
    changePrice()
  })

  $(function () {
    // 购物车加购动效
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      $('.sp-header-top .sp-cart .num').show()
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })

    let initNum = 0
    $('.product-part .cart-btn').click(function () {
      let spNum = $('.product-part #calcNumber')[0].value
      initNum += Number(spNum)

      // $("#calcNumber").val(1);
      // $("#cardNum").html(initNum);
      // $("#cardNum").removeClass("sp-gray");
      // handleAddToCart(initNum);
      var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('#cardNum').html(result.item_count)
            $('#cardNum').removeClass('sp-gray')
          })
        },
        dataType: 'json',
      })

      var img = $('.product-part .sp-img-p')
      // var img = $(".product-part .sp-swiper .swiper-slide-active .sp-img");

      var flyer = img[0].cloneNode(true)
      flyer.classList.add('sp_clone')

      $('.product-part').append(flyer)
      $('.sp_clone').css({
        width: img[0].width,
        height: img[0].height,
        background: '#e7e9ef',
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })

      let finish = $('.sp-cart')
      $('.sp_clone').animate(
        {
          // top: finish[0].offsetTop,
          top: finish[0].offsetTop + $('.time-part').height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach()
            }
          )
        }
      )
    })
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }
})
